<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-dnd-free3-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      stage: null,
      width: 0,
      height: 0,
      offset: {},
      images: [],
      containers: [],
      moved: 0,
      ticker: false,
      movesTo: [],
    };
  },
  beforeMount() {},
  mounted() {
    //  this.initData = _.cloneDeep(this.startGameConfig);
    //  this.initData = _.cloneDeep(this.startGameConfig);
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    if (this.startGameConfig.animation) {
      this.ticker = createjs.Ticker;
      this.ticker.framerate = 60;
      if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
      this.ticker.addEventListener('tick', this.tick);
      this.ticker.paused = true;
    }
    this.setStage();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    createContainer(obj) {
      var container = new createjs.Container();
      container.x = (Number.isInteger(obj.pos.x) ? obj.pos.x : 0) - this.offset.x;
      container.y = (Number.isInteger(obj.pos.y) ? obj.pos.y : 0) - this.offset.y;
      if (obj.id) container.name = obj.id;
      if (obj.bgr.split('/').length == 1) {
        let shape = new createjs.Shape();
        container.width = shape.width = Number.isInteger(obj.pos.w) ? obj.pos.w : this.width - container.x;
        container.height = shape.height = Number.isInteger(obj.pos.h) ? obj.pos.h : this.height - container.y;
        if (obj.border) {
          shape.graphics.ss(1).s(obj.border);
        }
        shape.graphics.f(obj.bgr).dr(0, 0, shape.width, shape.height).ef();
        if (obj.id) shape.id = obj.id;
        container.addChild(shape);
        this.stage.addChild(container);
      } else {
        let queue = new preload.LoadQueue();
        var self = this;
        queue.on('fileload', function (e) {
          let bmp = new createjs.Bitmap(e.result.src);
          if (e.item.id) bmp.id = e.item.id;
          e.item.cont.width = e.result.width;
          e.item.cont.height = e.result.height;
          e.item.cont.addChild(bmp);
        });
        queue.on('complete', function (e) {
          self.stage.update();
        });
        queue.loadManifest([{ cont: container, id: obj.id, src: obj.bgr }]);
      }
      return container;
    },
    setStage() {
      this.initData = _.cloneDeep(this.startGameConfig);
      this.width = this.initData.width ? this.initData.width : document.getElementById('game-container').offsetWidth;
      this.height = this.initData.height
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      // console.log(this.width + ' - ' + this.height);
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
      if (this.initData.imgs) {
        for (let i = 0; i < this.initData.imgs.length; i++) {
          this.stage.addChild(this.createContainer(this.initData.imgs[i]));
        }
      }
      var targets = [];
      if (this.initData.shuffleTargets) {
        var group = [];
        this.initData.targets.forEach(function (tar) {
          if (!group[tar.choose]) group[tar.choose] = [];
          group[tar.choose].push(tar);
        });
        group.forEach(function (tar) {
          let i = Math.floor(Math.random() * tar.length);
          targets.push(tar[i]);
        });
      } else targets = this.initData.targets;
      for (let i = 0; i < targets.length; i++) {
        let container = this.createContainer(targets[i]);
        this.stage.addChildAt(container, 0);
        this.containers[container.name] = {
          id: container.name,
          cont: container,
          correct: targets[i].correct,
          pos: targets[i].pos,
        };
        if (targets[i].exception) {
          this.containers[container.name].exception = targets[i].exception;
        }
      }
      this.initData.source.id = 'source';
      let container = this.createContainer(this.initData.source);
      this.stage.addChildAt(container, this.stage.children.length);
      this.containers[container.name] = { id: container.name, cont: container, indx: [] };
      this.loadImages();
      this.stage.update();
    },
    loadImages() {
      var self = this;
      var indx = [];
      var drawn = [];
      var exceptions = [];
      Object.getOwnPropertyNames(this.containers).forEach(function (val, idx, array) {
        if (self.containers[val].id && val != 'source') {
          drawn.push(val);
          if (self.containers[val].exception) Array.prototype.push.apply(exceptions, self.containers[val].exception);
          self.containers[val].correct.forEach(function (cor) {
            for (let i = 0; i < self.initData.samples.length; i++) {
              if (self.initData.samples[i].id == cor) {
                indx.push(i);
                break;
              }
            }
          });
        }
      });
      if (this.initData.pickNotDrawn > 0) {
        this.initData.targets.forEach(function (tar) {
          if (drawn.indexOf(tar.id) === -1) {
            var los = self.shuffle(tar.correct);
            if (exceptions.length > 0) {
              for (let i = 0; i < exceptions.length; i++) {
                if (los.indexOf(exceptions[i]) !== -1) {
                  los.splice(los.indexOf(exceptions[i]), 1);
                }
              }
            }
            los = self.shuffle(los);
            for (let i = 0; i < self.initData.pickNotDrawn; i++) {
              for (let j = 0; j < self.initData.samples.length; j++) {
                if (los[i] == self.initData.samples[j].id) {
                  indx.push(j);
                  break;
                }
              }
            }
          }
        });
      }
      var images = [];
      indx.forEach(function (ind, i) {
        images[i] = Object.assign({}, self.initData.samples[ind]);
      });
      var manifest = [];
      images.forEach(function (img) {
        manifest.push(img);
      });
      let queue = new preload.LoadQueue();
      queue.on('fileload', function (e) {
        self.handleFileLoad(e);
      });
      queue.on('complete', function (e) {
        self.handleComplete(e);
      });
      queue.loadManifest(manifest);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();
      this.stage.update();
      this.containers.splice(0, this.containers.length);
      this.containers = [];
      this.images.splice(0, this.images.length);
      this.moved = null;
      this.movesTo.splice(0, this.movesTo.length);
      this.setStage();
    },
    handleFileLoad(e) {
      var image = e.result;
      let bmp = new createjs.Bitmap(image.src);
      let container = this.stage.getChildByName('source');
      bmp.id = e.item.id;
      bmp.name = e.item.name;
      bmp.width = e.item.pos.w ? e.item.pos.w : image.width;
      bmp.height = e.item.pos.h ? e.item.pos.h : image.height;
      bmp.clones = 0;
      bmp.block = false;
      bmp.isCorrect = false;
      bmp.ix = this.images.length;
      if (e.item.pos.x) bmp.x = e.item.pos.x;
      if (e.item.pos.y) bmp.y = e.item.pos.y;
      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);
      this.images.push(bmp);
      container.addChild(bmp);
    },
    handleComplete(e) {
      var self = this;
      let container = this.containers['source'];
      let source = this.initData.source;
      var mod = 0,
        mod2 = 0,
        bb = 0,
        last = 0;
      this.images.forEach(function (bmp) {
        if (source.isHor) {
          bb = bb < bmp.height ? bmp.height : bb;
        } else {
          bb = bb < bmp.width ? bmp.width : bb;
        }
      });
      this.images.forEach(function (bmp, j) {
        if (!bmp.parent) container.cont.addChildAt(bmp, 1);
        bmp.ix = container.indx.length;
        if (!bmp.x && !bmp.y) {
          if (source.isHor) {
            if (j > 0) {
              mod =
                self.images[j - 1].x +
                  self.images[j - 1].width +
                  (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                  bmp.width >
                container.cont.width
                  ? 0
                  : mod + 1;
              if (mod == 0) {
                mod2++;
              }
              last =
                mod == 0 && mod2 > 0
                  ? (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                    bb +
                    self.images[j - 1].y -
                    (bb - self.images[j - 1].height) / 2
                  : last;
            } else last = source.margin && source.margin.top ? source.margin.top : 0;
            bmp.x =
              (source.margin && source.margin.left && mod == 0 ? source.margin.left : 0) +
              ((mod > 0 ? self.images[j - 1].width + self.images[j - 1].x : 0) +
                (source.margin && source.margin.lineH ? source.margin.lineH : 15));
            bmp.y = last + (bb - bmp.height) / 2;
          } else {
            if (j > 0) {
              mod =
                self.images[j - 1].y +
                  self.images[j - 1].height +
                  (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                  bmp.height >
                container.cont.height
                  ? 0
                  : mod + 1;
              if (mod == 0) {
                mod2++;
              }
              last =
                mod == 0 && mod2 > 0
                  ? (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                    bb +
                    self.images[j - 1].x -
                    (bb - self.images[j - 1].width) / 2
                  : last;
            } else last = source.margin && source.margin.left ? source.margin.left : 0;
            bmp.x = last + (bb - bmp.width) / 2;
            bmp.y =
              (source.margin && source.margin.top && mod == 0 ? source.margin.top : 0) +
              ((mod > 0 ? self.images[j - 1].height + self.images[j - 1].y : 0) +
                (source.margin && source.margin.lineH ? source.margin.lineH : 15));
          }
        }
        bmp.pos = { x: bmp.x, y: bmp.y };
        bmp.newPos = { x: bmp.x, y: bmp.y };
        container.indx.push({ x: bmp.x, y: bmp.y });
      });
      this.stage.update();
    },
    findContainer(e) {
      var cont = false,
        self = this;
      var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);
      items.forEach(function (obj) {
        if (self.containers[obj.id] && !cont) {
          cont = self.containers[obj.id];
        }
      });
      return cont ? cont : this.containers['source'];
    },
    findChildsByName(parent, name) {
      var childs = [];
      parent.children.forEach(function (child, i) {
        if (child.name == name) childs.push({ id: child.id, isCorrect: child.isCorrect });
      });
      return childs;
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var ix = -1,
        cont = this.findContainer(e);
      if (cont) {
        this.images.forEach(function (bmp, i) {
          if (e.target.id == bmp.id) {
            ix = i;
          }
        });
      }
      if (ix >= 0 && this.images[ix].block !== true) {
        let x = this.images[ix].parent.x;
        let y = this.images[ix].parent.y;
        if (this.initData.clone && cont.id == 'source') {
          let clone = this.images[ix].clone();
          clone.id = this.images[ix].id + 'clone' + this.images[ix].clones;
          clone.ix = ix;
          clone.on('mousedown', this.stageMouseDown);
          clone.on('pressup', this.stageMouseUp);
          this.images[ix].clones++;
          this.images.push(clone);
          ix = this.images.length - 1;
        }
        this.stage.addChildAt(this.images[ix], this.stage.children.length);
        this.moved = this.images[ix];
        this.stage.update();
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.moved.x += x;
        this.moved.y += y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
        this.mousedown = true;
      } else this.moved = null;
    },
    stageMouseMove(e) {
      if (this.mousedown && (this.ticker === false || this.ticker.paused)) {
        this.moved.x += e.stageX - this.moved.stageX - this.offset.x;
        this.moved.y += e.stageY - this.moved.stageY - this.offset.y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
        this.moved.x = Math.round(this.moved.x);
        this.moved.y = Math.round(this.moved.y);
        this.stage.update();
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var cont = this.findContainer(e);
        var drop = false;
        Object.keys(this.containers).forEach(function (key) {
          if (key != 'source' && key == cont.id && drop === false) drop = true;
        });
        if (drop) {
          this.moved.x -= cont.cont.x;
          this.moved.y -= cont.cont.y;
          this.containers[cont.id].cont.addChild(this.moved);
          if (Number.isInteger(this.containers[cont.id].pos.xs)) {
            this.moved.x = this.containers[cont.id].pos.xs;
          }
          if (Number.isInteger(this.containers[cont.id].pos.ys)) {
            this.moved.y = this.containers[cont.id].pos.ys;
          }
          this.stage.update();
        } else {
          if (this.ticker === false) {
            this.moved.x = this.moved.pos.x;
            this.moved.y = this.moved.pos.y;
            this.containers['source'].cont.addChild(this.moved);
          } else {
            this.moved.x += this.moved.parent.x;
            this.moved.y += this.moved.parent.y;
            this.containers['source'].cont.addChild(this.moved);
            this.movesTo.push(this.moved);
            this.ticker.paused = false;
          }
        }
        this.stage.update();
        this.stage.removeAllEventListeners('stagemousemove');
      }
    },
    anim(bmp, move) {
      if (move.move) {
        let count = 20;
        if (Math.abs(bmp.x - move.x) < count) bmp.x = move.x;
        if (bmp.x < move.x) bmp.x += count;
        else if (bmp.x > move.x) bmp.x -= count;
        if (Math.abs(bmp.y - move.y) < count) bmp.y = move.y;
        if (bmp.y < move.y) bmp.y += count;
        else if (bmp.y > move.y) bmp.y -= count;
      }
    },
    tick(e) {
      if (this.movesTo.length > 0) {
        for (let i = 0; i < this.movesTo.length; i++) {
          this.anim(this.movesTo[i], { x: this.movesTo[i].pos.x, y: this.movesTo[i].pos.y, move: true });
          if (this.movesTo[i].x == this.movesTo[i].pos.x && this.movesTo[i].y == this.movesTo[i].pos.y) {
            this.movesTo.splice(i, 1);
          }
          this.stage.update();
        }
      } else {
        if (!this.ticker.paused) {
          if (!this.mousedown) {
            this.ticker.paused = true;
            this.moved.move = false;
          }
          this.stage.update();
        }
      }
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;
      Object.keys(this.containers).forEach(function (key) {
        if (key != 'source') {
          if (self.containers[key].correct.length != self.containers[key].cont.children.length - 1) {
            isCorrect = false;
          }
          var moveChilds = [];
          self.containers[key].cont.children.forEach(function (child) {
            if (key != child.id) {
              var isCorrectChild = true;
              var childsId = self.findChildsByName(self.containers[key].cont, child.name);
              if (
                childsId.length == 1 &&
                self.containers[key].correct.indexOf(child.id) === -1 &&
                (self.containers[key].exception === undefined ||
                  (self.containers[key].exception && self.containers[key].exception.indexOf(child.id) === -1))
              )
                isCorrectChild = false;
              if (childsId.length > 1) {
                for (let i = 0; i < childsId.length; i++) {
                  if (childsId[i].id !== child.id && childsId[i].isCorrect) isCorrectChild = false;
                }
              }
              child.isCorrect = isCorrectChild;
              if (!isCorrectChild) {
                isCorrect = false;
                if (self.initData.removeInCorrects === true) {
                  if (self.ticker === false) {
                    child.x = child.pos.x;
                    child.y = child.pos.y;
                    moveChilds.push(child);
                  } else {
                    child.x += child.parent.x;
                    child.y += child.parent.y;
                    moveChilds.push(child);
                  }
                }
              } else {
                if (self.initData.corrBlock) child.block = true;
              }
            }
          });
          if (moveChilds.length > 0) {
            if (self.ticker === false) self.containers['source'].cont.addChild(moveChilds);
            else {
              moveChilds.forEach(function (child) {
                self.containers['source'].cont.addChild(child);
                child.x -= child.parent.x;
                child.y -= child.parent.y;
                self.movesTo.push(child);
              });
            }
          }
        }
      });
      this.stage.update();
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    if (this.ticker !== false) this.ticker.removeAllEventListeners();
    this.stage.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
